import { useState } from "react";
import "./APIExcipients.css";
import Breadcrumb from "../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";

const Services = () => {


  const polypropyleneProducts = [
    {
      id: 1,
      name: "ACETICACID",
      image: "/assets/img/api-excipients/aceticacid.png",
      usage: [
        {
          title: "FOOD INDUSTRY",
          points: [
            "Used as a preservative, flavoring agent, and acidulant in food products.",
            "A key component of vinegar, widely used in cooking, pickling, and as a condiment.",
            "Helps balance pH in various food items."
          ],
        },
        {
          title: "CHEMICAL INDUSTRY",
          points: [
            "Crucial raw material in the production of acetic anhydride, acetate esters, coatings, solvents, and plastics.",
            "Widely used in chemical manufacturing processes."
          ],
        },
        {
          title: "PHARMACEUTICALS",
          points: [
            "Used as a solvent in the production of medications.",
            "Applied in medical treatments for ear infections and as a topical antiseptic."
          ],
        },
        {
          title: "COSMETICS AND PERSONAL CARE",
          points: [
            "Used in hair care products like shampoos and conditioners for pH balance.",
            "Acts as an exfoliant in skin care products, helping improve texture."
          ],
        },
        {
          title: "AGRICULTURE",
          points: [
            "Sometimes used in herbicides for effective weed control.",
            "Acts as a pH regulator in agricultural solutions and formulations."
          ],
        },
        {
          title: "CLEANING PRODUCTS",
          points: [
            "Commonly used in household cleaners due to antibacterial and acidics properties.",
            "Helps dissolve mineral deposits, lime scale, and soap scum."
          ],
        },
      ],
    },

    {
      id: 2,
      name: "AMOXICILLINTRIHYDRATE(COMACTED)",
      image: "/assets/img/api-excipients/alphacypermethrin.png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: ["Tablets and Capsules The compacted form is specifically designed for direct compression in tablet manufacturing",
            "Improves production efficiency by enhancing flowability and reducing dusts formation",
            "Suspensions Utilized in oral liquid formulations for pediatric and geriatric patients",
            "Effective againsts bacterial infections, including respiratory tract infections, urinary tract infections, and skin infections.",
          ],
        },
        {
          title: "Veterinary Medicine",
          points: ["Oral Dosage Forms Used in formulations for treating bacterial infections in animals, particularly in oral dosage forms.",
            "Oral powders",
            "Suspensions",
            "Bolus tablets",
            "Premixes",
          ],
        },
        {
          title: "Manufacturing & Handling Benefits",
          points: ["Enhanced flow properties make it suitable for high-speed automatic machines.",
            "Reduced dust helps maintain cleaner production areas and reduces material loss.",
            "Better compressibility, resulting in stronger tablets with fewer defects.",
            "Improves overall processing efficiency and reduces downtime.",
          ],
        },
      ],
    },


    {
      id: 3,
      name: "AMOXICILLINTRIHYDRATE(LIGHT)",
      image: "/assets/img/api-excipients/amoxicillintrihydrate (2).png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: ["Used in Tablet and Capsule Manufacturing The compacted grade is ideal for direct compression, improving tablet hardness and uniformity.",
            "Enhanced Flowability The compacted form provides excellent flow properties, making it suitable for high-speed tablet production.",
            "Reduced Dust Formation Minimizes dust during processing, improving operator safety and maintaining a cleaner production environment.",
            "Suitable for Oral Suspensions Commonly used in pediatric and geriatric liquid formulations due to its good dispersibility.",
            "Used in Combination Formulations Often formulated with clavulanic acid to combat beta-lactamase–producing bacteria.",
          ],
        },
        {
          title: "Veterinary Medicine",
          points: [
            "Widely used veterinary antibiotic effective against a broad range of Gram-positive and Gram-negative bacterial infections in animals.",
            "Suitable for multiple species including cattle, poultry, swine, sheep, goats, horses, dogs, and cats.",
            "Applicable in oral dosage forms such as veterinary suspensions, powders, bolus tablets, and premixes.",
            "High absorption and bioavailability ensuring fast therapeutic action and reliable outcomes in animals.",
            "Compacted grade provides improved particle flow, making it ideal for large-scale veterinary formulation processing."
          ],
        }

      ],
    },


    {
      id: 4,
      name: "ASCORBICACID",
      image: "/assets/img/api-excipients/ascorbicacid.png",
      usage: [
        {
          title: "Food and Beverage Industry",
          points: [
            "Preservative – Prevents oxidation and spoilage in processed foods and beverages.",
            "Antioxidant – Maintains color, flavor, and nutrients in juices, jams, and canned goods.",
            "Fortification – Adds nutritional value to cereals, snacks, and beverages.",
          ]
        },
        {
          title: "Pharmaceutical Industry",
          points: [
            "Dietary supplements – Used in tablets, capsules, and powders to prevent or treat vitamin C deficiency (scurvy).",
            "Therapeutic use – Supports immune function, aids in wound healing, and protects cells from oxidative stress.",
          ]
        },
        {
          title: "Cosmetic Industry",
          points: [
            "Skincare products – Used in creams, serums, and masks for antioxidant benefits and brightening skin tone.",
            "Anti-aging – Helps reduce fine lines and wrinkles by supporting collagen synthesis and improving skin elasticity.",
          ]
        },
        {
          title: "Industrial Applications",
          points: [
            "Anti-browning agent – Prevents discoloration in fresh-cut fruits and vegetables.",
            "pH adjuster – Used to stabilize formulations in chemical and industrial processes.",
          ],
        },
      ],
    },

    {
      id: 5,
      name: "AZITHROMYCINDIHYDRATE",
      image: "/assets/img/api-excipients/azithromycindihydrate.png",
      usage: [
        {
          title: "PHARMACEUTICAL INDUSTRY",
          points: [
            "Antibiotic treatment used to treat bacterial infections such as pneumonia, bronchitis, ear infections, and sexually transmitted infections (STIs) like chlamydia and gonorrhea.",
            "Used in the treatment of infections associated with inflammatory conditions, as it also has mild anti-inflammatory effects.",
            "Employed in some cases as a preventive measure for infections, particularly in immunocompromised patients.",
          ],
        },
        {
          title: "VETERINARY USE",
          points: [
            "Used in veterinary medicine to treat bacterial infections in animals, particularly respiratory infections in livestock and pets.",
            "Helps treat skin and soft tissue infections in animals, especially dogs and cats.",
            "Often used for treating gastrointestinal infections caused by susceptible bacteria.",
            "Administered in poultry farming to control respiratory and systemic bacterial infections.",
          ],
        },
      ],
    },

    {
      id: 6,
      name: "CAFFEINEANHYDROUS",
      image: "/assets/img/api-excipients/caffeineanhydrous.png",
      usage: [
        {
          title: "PHARMACEUTICAL INDUSTRY",
          points: [
            "Used in stimulant drugs to combat fatigue and increase alertness.",
            "Commonly combined with aspirin or acetaminophen in pain relievers to enhance effectiveness.",
            "Included in respiratory treatments for conditions such as apnea in newborns.",
          ],
        },
        {
          title: "FOOD & BEVERAGE INDUSTRY",
          points: [
            "Widely used as a stimulant ingredient in energy drinks, soft drinks, and functional beverages.",
            "Added to dietary supplements to improve mental focus and reduce fatigue.",
            "Used in sports nutrition products to enhance physical performance and endurance.",
          ],
        },
        {
          title: "COSMETICS INDUSTRY",
          points: [
            "Used in anti-cellulite products to improve skin texture by promoting blood flow.",
            "Added to eye creams to reduce puffiness and dark circles by constricting blood vessels.",
            "Used in shampoos and hair care formulations to stimulate hair follicles and reduce hair loss.",
          ],
        },
      ],
    },



    {
      id: 7,
      name: "CETYLALCOHOL",
      image: "/assets/img/api-excipients/cetylalcohol.png",
      usage: [
        {
          title: "COSMETICS & PERSONAL CARE PRODUCTS",
          points: [
            "Used as an emollient, emulsifier, and thickening agent in creams, lotions, shampoos, and conditioners to enhance texture and stability.",
            "Acts as a product stability enhancer, imparting a smooth and luxurious texture to formulations.",
          ],
        },
        {
          title: "PHARMACEUTICALS",
          points: [
            "Used as a stabilizer and thickener in ointments, creams, and topical medications to improve consistency and efficacy.",
            "Helps enhance formulation consistency for effective delivery of active ingredients.",
          ],
        },
        {
          title: "INDUSTRIAL USES",
          points: [
            "Used in the production of surfactants and detergents for cleaning and foaming applications.",
            "Functions as a lubricant in various industrial processes.",
          ],
        },
      ],
    },




    {
      id: 8,
      name: "CITRICACID(ANHYDROUS)",
      image: "/assets/img/api-excipients/citricacid.png",
      usage: [
        {
          title: "FOOD INDUSTRY",
          points: [
            "Used as a preservative, flavoring agent, and acidulant in various food products.",
            "Key component of vinegar substitutes and widely used in cooking, pickling, and as a condiment.",
            "Helps balance pH levels in food and enhances shelf life.",
          ],
        },
        {
          title: "CHEMICAL INDUSTRY",
          points: [
            "Used as a raw material in the production of acetic anhydride, acetate esters, solvents, coatings, and plastics.",
            "Important for manufacturing buffering agents and industrial chemical formulations.",
          ],
        },
        {
          title: "PHARMACEUTICALS",
          points: [
            "Used as a solvent in medication production and pharmaceutical formulations.",
            "Applied in medical treatments such as ear infection solutions and topical antiseptics.",
          ],
        },
        {
          title: "COSMETICS AND PERSONAL CARE",
          points: [
            "Used in shampoos and conditioners as a pH balancer.",
            "Included in skincare products as an exfoliant and for improving skin texture.",
          ],
        },
        {
          title: "AGRICULTURE",
          points: [
            "Sometimes used in herbicides for effective weed control.",
            "Acts as a pH regulator in various agricultural nutrient and spray solutions.",
          ],
        },
        {
          title: "CLEANING PRODUCTS",
          points: [
            "Used in household cleaners due to its antibacterial and acidic properties.",
            "Helps dissolve mineral deposits, lime scale, rust stains, and soap scum.",
          ],
        },
      ],
    },



    {
      id: 9,
      name: "CITRICACIDS(ANHYDROUS)",
      image: "/assets/img/api-excipients/citricacids.png",
      usage: [
        {
          title: "VETERINARY MEDICINE",
          points: [
            "Used for treating respiratory infections in livestock such as cattle, swine, and poultry caused by pathogens like Pasteurella spp., Actinobacillus pleuropneumoniae, and Haemophilus spp.",
            "Effective in treating gastrointestinal infections in animals caused by bacteria such as E. coli and Salmonella.",
            "Helps manage skin infections in animals, including wounds and abscesses caused by bacterial pathogens.",
          ],
        },
        {
          title: "FISH FARMING (AQUACULTURE)",
          points: [
            "Used to treat bacterial infections in fish caused by pathogens like Vibrio spp. and Aeromonas spp.",
            "Helps reduce fish mortality and prevents spread of bacterial diseases in aquaculture systems.",
          ],
        },
        {
          title: "PROPHYLACTIC USE IN LIVESTOCK",
          points: [
            "Used as a preventive treatment for bacterial infections in high-risk livestock populations.",
            "Administered after surgeries or stressful conditions to reduce the chance of bacterial outbreaks.",
          ],
        },
      ],
    },



    {
      id: 10,
      name: "DPANTHENOL",
      image: "/assets/img/api-excipients/dpanthenol.png",
      usage: [
        {
          title: "COSMETICS & PERSONAL CARE PRODUCTS",
          points: [
            "Acts as a moisturizer that improves skin hydration and reduces dryness.",
            "Helps in healing minor wounds and soothing irritated or sensitive skin.",
            "Reduces redness and inflammation, making it ideal for acne-prone or sensitive skin.",
            "Strengthens hair by improving elasticity and moisture retention.",
            "Adds shine, softness, and volume to hair while preventing breakage and split ends.",
            "Improves nail strength, flexibility, and prevents brittleness."
          ],
        },
        {
          title: "PHARMACEUTICALS",
          points: [
            "Promotes skin cell regeneration and accelerates wound and burn healing.",
            "Used in ointments and creams for treating cuts, scrapes, and minor burns.",
            "Helps in treating eczema, dermatitis, and other inflammatory skin conditions.",
            "Commonly used in diaper rash and sunburn relief formulations."
          ],
        },
        {
          title: "INDUSTRIAL USES",
          points: [
            "Used in animal feed to improve coat and skin health of livestock.",
            "Enhances immune response in animals as part of nutritional supplements.",
            "Added to foods and beverages for nutrient enrichment.",
            "Incorporated in pharmaceutical syrups and tablets to boost overall health and energy."
          ],
        },
      ],
    },




    {
      id: 11,
      name: "FOLICACID(INJECTION GRADE)",
      image: "/assets/img/api-excipients/folicacid.png",
      usage: [
        {
          title: "Treatment of Folic Acid Deficiency",
          points: [
            "Prevention and Treatment of Anemia: Stimulates production of healthy red blood cells to treat megaloblastic anemia caused by folate deficiency.",
            "Correction of Folic Acid Deficiency: Helps correct folate deficiencies, reducing symptoms such as fatigue, weakness, and irritability."
          ],
        },
        {
          title: "Pregnancy Support",
          points: [
            "Prevention of Neural Tube Defects: Crucial during pregnancy to prevent birth defects in the brain and spinal cord; recommended for women of childbearing age and early pregnancy.",
            "Support for Maternal Health: Aids in cell division and formation of the placenta, supporting overall maternal health."
          ],
        },
        {
          title: "General Health and Wellness",
          points: [
            "Cellular Function: Essential for DNA synthesis, cell division, and tissue growth, supporting healthy cellular functions.",
            "Cardiovascular Health: Can help lower homocysteine levels, reducing the risk of heart disease when used with other treatments."
          ],
        },
        {
          title: "Intravenous and Intramuscular Administration",
          points: [
            "Parenteral Formulation: Administered via IV or IM injection when oral supplementation is not feasible or higher doses are required for rapid correction of deficiency."
          ],
        }
      ],
    },




    {
      id: 12,
      name: "GLYCERIN",
      image: "/assets/img/api-excipients/glycerin.png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: [
            "Topical Applications: Used in creams, ointments, and lotions for moisturizing properties.",
            "Cough Syrups: Serves as a soothing agent.",
            "Suppositories: Acts as a laxative for bowel regulation.",
            "Capsules and Tablets: Works as a solvent or plasticizer."
          ],
        },
        {
          title: "Personal Care & Cosmetics",
          points: [
            "Moisturizers and Skincare Products: Prevents dryness by retaining moisture.",
            "Toothpaste: Helps maintain smooth texture and prevents drying out.",
            "Haircare Products: Adds moisture and shine to hair.",
            "Soap Manufacturing: Provides transparency and emollient properties."
          ],
        },
        {
          title: "Food & Beverage Industry",
          points: [
            "Sweetener: Used in sugar-free and low-sugar products.",
            "Preservative: Prevents moisture loss in food.",
            "Texturizer: Improves consistency in baked goods, candies, and dairy products."
          ],
        },
        {
          title: "Industrial Applications",
          points: [
            "Antifreeze: Used in automotive applications for its low freezing point.",
            "Plastic Manufacturing: Serves as a plasticizer.",
            "Explosives: Critical ingredient in nitroglycerin production.",
            "Paints and Coatings: Enhances flow and prevents cracking."
          ],
        },
        {
          title: "Health & Wellness",
          points: [
            "Vaping Liquids: Used as a base for e-cigarette liquids.",
            "Pet Care: Included in pet treats and medications.",
            "Herbal Extractions: Acts as a solvent in non-alcoholic tinctures."
          ],
        }
      ],
    },





    {
      id: 13,
      name: "IRBESARTAN",
      image: "/assets/img/api-excipients/irbesartan.png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: [
            "Tablets and Capsules: Formulated as monotherapy or in combination with other antihypertensive agents such as hydrochlorothiazide.",
            "Hypertension Management: Reduces the risk of cardiovascular events in patients with high blood pressure.",
            "Diabetic Nephropathy: Slows the progression of kidney disease in patients with type 2 diabetes and hypertension."
          ],
        }
      ],
    },



    {
      id: 14,
      name: "LEUCINE",
      image: "/assets/img/api-excipients/leucine.png",
      usage: [
        {
          title: "Muscle Growth and Recovery",
          points: [
            "Protein Synthesis and Muscle Protection: Stimulates muscle protein synthesis, promoting muscle growth and recovery after exercise.",
            "Prevents Muscle Breakdown: Helps prevent catabolism during fasting, intense exercise, or stress, protecting muscle tissue."
          ],
        },
        {
          title: "Nutritional Supplements",
          points: [
            "Support for Muscle Health: Part of the BCAAs (with isoleucine and valine), used in dietary supplements to enhance muscle health, endurance, and recovery.",
            "Clinical Nutrition: Used for patients with malnutrition, muscle wasting, or conditions requiring enhanced protein intake."
          ],
        },
        {
          title: "Medical Applications",
          points: [
            "Treatment and Recovery Aid: Helps manage conditions like cachexia in chronic illnesses such as cancer or AIDS by improving muscle mass and nutritional status.",
            "Support for Elderly and Post-Surgery Patients: Recommended to maintain muscle mass and improve recovery outcomes."
          ],
        }
      ],
    },


    {
      id: 15,
      name: "LIGHTLIQUIDPARAFFIN OIL",
      image: "/assets/img/api-excipients/lightliquidparaffinoil.png",
      usage: [
        {
          title: "Pharmaceutical and Cosmetic Industry",
          points: [
            "Sweetening Agent / Base for Ointments and Creams: Used as an emollient in topical formulations to soothe and protect the skin.",
            "Laxatives: Ingredient in medicinal formulations like liquid paraffin laxatives.",
            "Moisturizers: Incorporated into lotions and creams for hydrating properties.",
            "Hair Care Products: Used in hair oils, conditioners, and styling products for non-greasy lubrication."
          ],
        },
        {
          title: "Food and Beverage Industry (Food Grade)",
          points: [
            "Food-Grade Applications: Acts as a release agent, anti-sticking agent, or lubricant in food processing.",
            "Coating for Fruits and Vegetables: Applied as a thin layer to preserve freshness and gloss."
          ],
        },
        {
          title: "Industrial Applications",
          points: [
            "Lubricants: Serves as a lubricant in machinery where food-grade oils are required.",
            "Metalworking Fluids: Used in cutting, grinding, and machining processes as a cooling agent.",
            "Plastic and Polymer Industry: Functions as a plasticizer or mold release agent."
          ],
        },
        {
          title: "Chemical Synthesis and Industrial Processes",
          points: [
            "Carrier Fluid: Acts as a medium in chemical reactions requiring a stable, inert liquid.",
            "Diluent for Additives: Helps blend additives like dyes, pigments, and fragrances."
          ],
        },
        {
          title: "Textile and Leather Industry",
          points: [
            "Softener and Finishing Agent: Provides a smooth texture to fabrics and leather."
          ],
        },
        {
          title: "Agriculture",
          points: [
            "Pesticide Carrier: Used as a medium for formulating pesticides and herbicides."
          ],
        },
        {
          title: "Miscellaneous Uses",
          points: [
            "Candles and Polishes: Acts as a base in wax and polishing agents.",
            "Printing Inks: Enhances ink properties for specific industrial applications."
          ],
        }
      ],
    },





    {
      id: 16,
      name: "LIQUORICE(GLYCYRRHIZA)EXTRACT 10%",
      image: "/assets/img/api-excipients/LIQUORICE.png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: [
            "Anti-inflammatory and Antioxidant: Used in formulations for soothing sore throats, coughs, and other respiratory issues.",
            "Digestive Health: Treats indigestion, heartburn, and ulcers due to its anti-inflammatory and soothing properties.",
            "Skin Care: Incorporated in topical creams and ointments for anti-inflammatory and healing effects, especially for eczema, acne, and psoriasis."
          ],
        },
        {
          title: "Cosmetic Industry",
          points: [
            "Skin Whitening: Helps reduce pigmentation and even out skin tone in skincare products.",
            "Anti-aging: Provides antioxidant benefits in anti-aging formulations to combat free radicals and reduce fine lines and wrinkles."
          ],
        },
        {
          title: "Food and Beverage Industry",
          points: [
            "Flavoring Agent: Used in candies, beverages, and confectionery for its characteristic sweet taste.",
            "Herbal Supplements: Included in herbal supplements for soothing and digestive benefits."
          ],
        },
        {
          title: "Traditional Medicine",
          points: [
            "Cough and Cold Remedies: Used in herbal teas and syrups to treat coughs, colds, and sore throats."
          ],
        }
      ],
    },





    {
      id: 17,
      name: "LUTEIN10%",
      image: "/assets/img/api-excipients/lutein.png",
      usage: [
        {
          title: "Eye Health",
          points: [
            "Protection Against Macular Degeneration: Protects eyes from oxidative stress and helps prevent age-related macular degeneration (AMD) by filtering harmful blue light.",
            "Improved Visual Function: Regular supplementation is linked to better visual performance, especially in low-light conditions."
          ],
        },
        {
          title: "Skin Health",
          points: [
            "Antioxidant Protection: Helps protect skin from UV damage and oxidative stress, reducing visible signs of aging like wrinkles and fine lines.",
            "Hydration and Elasticity: Supports skin hydration and elasticity, contributing to a healthy, youthful appearance."
          ],
        },
        {
          title: "General Antioxidant Support",
          points: [
            "Free Radical Neutralization: Potent antioxidant that helps neutralize free radicals, supporting overall health and reducing risk of chronic diseases associated with oxidative stress."
          ],
        },
        {
          title: "Dietary Supplements",
          points: [
            "Vision and Skin Care Supplements: Commonly included in supplements aimed at promoting eye health, improving skin appearance, and providing antioxidant protection."
          ],
        }
      ],
    },




    {
      id: 18,
      name: "MAGNESIUMHYDROXIDEBP",
      image: "/assets/img/api-excipients/magnesiumhydroxide.png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: [
            "Antacid: Relieves heartburn, indigestion, and upset stomach by neutralizing excess stomach acid.",
            "Laxative: Acts as a gentle laxative by drawing water into the intestines to ease bowel movements."
          ],
        },
        {
          title: "Water Treatment",
          points: [
            "Neutralizing Agent: Used to neutralize acidic water and adjust pH levels.",
            "Wastewater Treatment: Applied in treating wastewater and removing heavy metals from industrial effluents."
          ],
        },
        {
          title: "Industrial Applications",
          points: [
            "Flame Retardant: Used in producing fire-resistant materials, particularly in plastics and rubber.",
            "Manufacturing of Chemicals: Employed in the production of other chemicals such as magnesium salts."
          ],
        },
        {
          title: "Cosmetic Industry",
          points: [
            "Skin Care Products: Added to some skincare formulations for its soothing and anti-inflammatory properties."
          ],
        }
      ],
    },




    {
      id: 19,
      name: "MAGNESIUMSULPHATE",
      image: "/assets/img/api-excipients/magnesiumsulphate.png",
      usage: [
        {
          title: "Agricultural Industry",
          points: [
            "Fertilizer: Provides magnesium and sulfur to promote healthy growth in crops like tomatoes, potatoes, and peppers.",
            "Soil Conditioner: Helps improve soil quality and nutrient content."
          ],
        },
        {
          title: "Pharmaceutical Industry",
          points: [
            "Magnesium Supplementation: Used in IV or oral formulations to treat magnesium deficiency.",
            "Eclampsia Treatment: Administered intravenously to control seizures in pregnant women with preeclampsia or eclampsia.",
            "Laxative: Acts as a mild laxative in certain medical treatments."
          ],
        },
        {
          title: "Industrial Applications",
          points: [
            "Manufacturing: Used in the production of textiles, paper, and various chemical processes.",
            "Water Treatment: Applied to remove impurities in water treatment processes."
          ],
        },
        {
          title: "Cosmetic Industry",
          points: [
            "Bath Soaks: Included in bath salts and body scrubs for soothing and muscle-relaxing properties."
          ],
        }
      ],
    },




    {
      id: 20,
      name: "MEBEVERINEHYDROCHLORIDE",
      image: "/assets/img/api-excipients/mebeverinehydrochloride.png",
      usage: [
        {
          title: "Treatment of Irritable Bowel Syndrome (IBS)",
          points: [
            "Relief of Abdominal Pain and Discomfort: Relieves symptoms of IBS including abdominal pain, bloating, and discomfort by relaxing smooth muscles of the intestines.",
            "Regulation of Bowel Movements: Reduces spasms that can lead to diarrhea or constipation, improving bowel function."
          ],
        },
        {
          title: "Gastrointestinal Disorders",
          points: [
            "Spasms in the Digestive Tract: Treats gastrointestinal disorders involving smooth muscle spasms, such as colitis or spastic colon.",
            "Post-Operative Bowel Recovery: Sometimes used after abdominal surgery to relieve bowel dysfunction caused by spasm."
          ],
        },
        {
          title: "Symptom Management in Other Digestive Disorders",
          points: [
            "Functional Digestive Disorders: Helps manage functional digestive disorders that cause discomfort, bloating, and irregular bowel movements, improving quality of life."
          ],
        }
      ],
    },


    {
      id: 21,
      name: "METFORMINHYDROCHLORIDE",
      image: "/assets/img/api-excipients/metforminhydrochloride.png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: [
            "Diabetes Treatment: Manages blood sugar levels in patients with type 2 diabetes without significantly increasing insulin secretion.",
            "Polycystic Ovary Syndrome (PCOS): Used off-label to improve insulin sensitivity and regulate menstrual cycles.",
            "Weight Management: May aid in weight loss in individuals with type 2 diabetes or obesity by improving insulin sensitivity and reducing appetite."
          ],
        },
        {
          title: "Veterinary Use",
          points: [
            "Animal Infections: Studied for potential use in managing insulin resistance in animals, particularly in horses and pets with obesity or metabolic disorders."
          ],
        }
      ],
    },




    {
      id: 22,
      name: "NICOTINAMIDE(INJECTION GRADE)",
      image: "/assets/img/api-excipients/nicotinamide.png",
      usage: [
        {
          title: "Medical and Therapeutic Use",
          points: [
            "Treatment of Pellagra: Restores normal metabolic function and alleviates symptoms of Vitamin B3 deficiency such as dermatitis, diarrhea, and dementia.",
            "Metabolic Disorders: Used to address various metabolic disorders related to nicotinic acid deficiency."
          ],
        },
        {
          title: "Skin Care and Dermatology",
          points: [
            "Topical Application: Used in dermatological treatments for acne, rosacea, and hyperpigmentation due to its anti-inflammatory properties.",
            "Anti-Aging and Skin Health: Included in injectable skin care treatments to promote skin repair, enhance barrier function, and reduce visible signs of aging."
          ],
        },
        {
          title: "Intravenous Formulations",
          points: [
            "Parenteral Nutrition: Included in IV nutrition formulations to provide essential nutrients to patients unable to consume food orally."
          ],
        }
      ],
    },

    {
      id: 23,
      name: "PARACETAMOLPOWDER",
      image: "/assets/img/api-excipients/paracetamolpowder.png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: [
            "Active Pharmaceutical Ingredient (API): Used as an API in analgesic and antipyretic medications."
          ],
        },
        {
          title: "Formulation Additives",
          points: [
            "Dosage Forms: Incorporated into tablets, capsules, syrups, and suspensions."
          ],
        },
        {
          title: "Industrial Use",
          points: [
            "Bulk Drug Production: Used in the large-scale production of pain relief and fever-reducing drugs."
          ],
        }
      ],
    },



    {
      id: 24,
      name: "POTASSIUMSORBATE",
      image: "/assets/img/api-excipients/potassiumsorbate.png",
      usage: [
        {
          title: "Food and Beverage Industry",
          points: [
            "Preservative: Used in cheeses, baked goods, dried fruits, syrups, pickles, and fruit juices to prevent growth of molds, yeasts, and bacteria, extending shelf life."
          ],
        },
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Product Preservation: Acts as a preservative in lotions, shampoos, deodorants, and creams to prevent microbial contamination and maintain product safety and efficacy."
          ],
        },
        {
          title: "Pharmaceuticals",
          points: [
            "Preservative in Medications: Ensures microbial stability and product integrity in pharmaceutical formulations."
          ],
        },
        {
          title: "Agriculture",
          points: [
            "Fungicide: Used in certain pesticides and plant growth products to prevent fungal growth."
          ],
        }
      ],
    },



    {
      id: 25,
      name: "PROPYLGALLATE",
      image: "/assets/img/api-excipients/propygallate.png",
      usage: [
        {
          title: "Food and Beverage Industry",
          points: [
            "Preservative and Flavor Enhancer: Used in oils, fats, processed foods, margarine, salad dressings, packaged snacks, processed meats, beverages, and confectionery to prevent rancidity and extend shelf life."
          ],
        },
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Antioxidant and Preservative: Prevents oxidation of oils and active ingredients in creams, lotions, and shampoos, preserving efficacy and stability."
          ],
        },
        {
          title: "Pharmaceuticals",
          points: [
            "Antioxidant and Preservative: Stabilizes formulations containing oils, such as oral suspensions and injectable drugs, preventing oxidative degradation and maintaining shelf life."
          ],
        }
      ],
    },




    {
      id: 26,
      name: "SODIUMBENZOATE",
      image: "/assets/img/api-excipients/sodiumbenzoate.png",
      usage: [
        {
          title: "Food and Beverage Industry",
          points: [
            "Preservative: Used in soft drinks, fruit juices, pickles, sauces, jams, and salad dressings to prevent growth of harmful bacteria, yeast, and molds."
          ],
        },
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Product Preservation: Maintains safety and efficacy in shampoos, lotions, deodorants, and creams by preventing microbial contamination."
          ],
        },
        {
          title: "Pharmaceuticals",
          points: [
            "Preservative in Medications: Used in syrups and liquid medications to prevent microbial growth and extend shelf life; also serves as an excipient in some drugs."
          ],
        }
      ],
    },



    {
      id: 27,
      name: "SODIUMLAURYLETHERSULFATE70%",
      image: "/assets/img/api-excipients/sodium.png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: [
            "Stimulant Drugs: Used in medications to combat fatigue and increase alertness.",
            "Pain Relievers: Commonly combined with aspirin or acetaminophen to enhance effectiveness.",
            "Respiratory Treatments: Included in treatments for conditions like apnea in newborns.",
            "Medicated Shampoos and Cleansers: Used for its emulsifying and foaming properties.",
            "Drug Formulation Aid: Acts as a wetting and dispersing agent in drug formulations."
          ],
        },
        {
          title: "Food & Beverage Industry",
          points: [
            "Processing Aid and Emulsifier: Occasionally used in non-consumable applications, such as cleaning solutions for food processing equipment.",
            "Hygiene Support: Supports hygiene in food preparation setups."
          ],
        },
        {
          title: "Cosmetics Industry",
          points: [
            "Anti-cellulite Products: Improves skin texture by promoting blood flow.",
            "Eye Creams: Reduces puffiness and dark circles by constricting blood vessels.",
            "Shampoos and Hair Care: Stimulates hair follicles and reduces hair loss."
          ],
        },
        {
          title: "Industrial Applications",
          points: [
            "Cleaning Agents: Used in industrial detergents and degreasers due to its surfactant properties.",
            "Textile and Leather Industry: Utilized for wetting and scouring processes."
          ],
        },
        {
          title: "Personal Care Products",
          points: [
            "Shampoos, Body Washes, and Liquid Soaps: Essential for manufacturing these products.",
            "Cleansing Agent: Provides rich lather and effective cleansing while being cost-efficient."
          ],
        }
      ],
    },




    {
      id: 28,
      name: "SULPIRIDE",
      image: "/assets/img/api-excipients/sulpiride.png",
      usage: [
        {
          title: "Pharmaceutical Industry",
          points: [
            "Antipsychotic Treatment: Administered to animals for treating bacterial infections in livestock and pets.",
            "Antidepressant: Sometimes prescribed for depression, particularly in patients unresponsive to other medications.",
            "Gastrointestinal Disorders: Used as a prokinetic agent to treat dyspepsia and irritable bowel syndrome (IBS)."
          ],
        },
        {
          title: "Other Uses",
          points: [
            "Anxiolytic: Used in some cases to treat anxiety disorders."
          ],
        }
      ],
    },




    {
      id: 29,
      name: "VITAMINAPALMITATE",
      image: "/assets/img/api-excipients/vitaminapalmitate.png",
      usage: [
        {
          title: "Vision Health",
          points: [
            "Prevention of Night Blindness: Essential for rhodopsin formation in the retina, supporting low-light vision and overall eye health.",
            "Macular Health: Maintains macula health, reducing the risk of age-related macular degeneration (AMD)."
          ],
        },
        {
          title: "Immune System Support",
          points: [
            "Boosting Immunity: Enhances immune function by supporting white blood cell production and activity.",
            "Skin and Mucosal Integrity: Maintains integrity of skin and mucosal barriers, the body’s first line of defense against pathogens."
          ],
        },
        {
          title: "Skin Health",
          points: [
            "Skin Cell Growth: Regulates skin cell growth and differentiation, preventing dry, flaky skin.",
            "Anti-Aging: Retinoids derived from Vitamin A promote collagen production and reduce the appearance of wrinkles and fine lines."
          ],
        },
        {
          title: "Dietary Supplements",
          points: [
            "Fortification of Foods: Used to fortify dairy products, cereals, and baby foods to prevent Vitamin A deficiency.",
            "Oral Supplements: Included in dietary supplements to improve overall health, support vision, and boost immunity."
          ],
        }
      ],
    },


    {
      id: 30,
      name: "VITAMIND3",
      image: "/assets/img/api-excipients/vitamin.png",
      usage: [
        {
          title: "Bone Health",
          points: [
            "Calcium Absorption: Promotes absorption of calcium and phosphorus in the intestines, essential for strong bones and teeth; helps prevent rickets and osteomalacia.",
            "Bone Density: Helps maintain bone density and reduce fracture risk, especially in older adults."
          ],
        },
        {
          title: "Immune System Support",
          points: [
            "Immune Function: Modulates the immune system, enhancing pathogen-fighting effects of immune cells and reducing inflammation.",
            "Protection Against Infections: Reduces the risk of respiratory infections such as flu and common cold."
          ],
        },
        {
          title: "Mood and Mental Health",
          points: [
            "Mood Regulation: Influences mood regulation and may help manage depression, particularly seasonal affective disorder (SAD).",
            "Cognitive Function: Adequate levels are linked to improved cognitive function and reduced risk of cognitive decline in older adults."
          ],
        },
        {
          title: "Dietary Supplementation",
          points: [
            "Fortification of Foods: Used to fortify milk, cereals, and plant-based alternatives to prevent Vitamin D deficiency.",
            "Oral Supplements: Used in concentrated forms for individuals with low Vitamin D levels or limited sun exposure."
          ],
        },
        {
          title: "Support for Healthy Pregnancy",
          points: [
            "Pregnancy Health: Essential for maternal and fetal health, supports fetal bone development, and helps prevent complications such as preeclampsia."
          ],
        }
      ],
    },

    {
      id: 31,
      name: "ALPHA-CYPERMETHRIN",
      image: "/assets/img/api-excipients/ALPHACYPERMETHRIN.png",
      usage: [
        {
          title: "Agricultural Applications",
          points: [
            "Insect Control: Highly effective pyrethroid pesticide used to control a wide range of agricultural pests including bollworms, aphids, jassids, whiteflies, and caterpillars.",
            "Crop Protection: Commonly used on cotton, vegetables, fruits, cereals, and oilseed crops to reduce pest damage and increase crop yield.",
            "Low Application Rate: Provides strong insecticidal action even at low doses, making it cost-effective for farmers."
          ],
        },
        {
          title: "Public Health Applications",
          points: [
            "Mosquito Control: Used in vector control programs to reduce mosquito populations responsible for malaria, dengue, and chikungunya.",
            "Indoor Residual Spraying (IRS): Applied on interior walls for long-lasting control of mosquitoes and other vectors.",
            "Outdoor Fogging: Used in fogging operations to manage mosquito outbreaks in public areas."
          ],
        },
        {
          title: "Veterinary Use",
          points: [
            "Livestock Protection: Helps control ticks, lice, mites, and flies on cattle, sheep, goats, and poultry.",
            "Animal Housing Treatment: Used to disinfect barns, sheds, and poultry houses against crawling and flying insects."
          ],
        },
        {
          title: "Household and Industrial Applications",
          points: [
            "Household Pest Control: Used in sprays, coils, mats, and liquid vaporizer formulations to kill cockroaches, ants, flies, and mosquitoes.",
            "Termite and Wood Borer Protection: Added to wood-preserving chemicals to prevent wood-damaging insects.",
            "Industrial Fumigation: Used in warehouses, food storage facilities, and factories for pest management."
          ],
        },
        {
          title: "Mode of Action & Benefits",
          points: [
            "Mode of Action: Acts on the insect nervous system, causing paralysis and death by interfering with sodium channel function.",
            "Fast Knockdown: Provides quick action against insects with strong residual effects.",
            "Stability: Resistant to light degradation compared to other insecticides, making it suitable for outdoor use."
          ],
        }
      ],
    },

    {
      id: 32,
      name: "DELTAMETHRIN",
      image: "/assets/img/api-excipients/DELTAMETHRIN.png",
      usage: [
        {
          title: "Agricultural Applications",
          points: [
            "Broad-Spectrum Pest Control: Effective against a wide range of insects including bollworms, aphids, jassids, whiteflies, beetles, and caterpillars.",
            "Crop Protection: Commonly used on cotton, vegetables, fruits, cereals, pulses, and oilseeds to prevent yield loss.",
            "Low Dose Effectiveness: Highly potent pyrethroid insecticide that works effectively even at low application rates."
          ],
        },
        {
          title: "Public Health Applications",
          points: [
            "Mosquito Control: Widely used in malaria, dengue, chikungunya, and Zika vector control programs.",
            "Indoor Residual Spraying (IRS): Applied on walls and surfaces to provide long-term mosquito and vector control.",
            "Space Spraying: Used for fogging operations in public areas to reduce mosquito populations during outbreaks."
          ],
        },
        {
          title: "Veterinary and Livestock Use",
          points: [
            "Ectoparasite Control: Helps control ticks, lice, flies, and mites on livestock animals such as cattle, goats, sheep, and poultry.",
            "Housing Treatment: Used for disinfecting and treating barns, stables, and poultry sheds to eliminate insects."
          ],
        },
        {
          title: "Household and Industrial Applications",
          points: [
            "Household Pest Control: Used in insecticide sprays, coils, vaporizers, and powders to control cockroaches, ants, mosquitoes, and flies.",
            "Stored Grain Protection: Effective in warehouses and storage units to protect grains from beetles and moth infestations.",
            "Wood & Material Protection: Used in treatments to prevent damage from termites and wood-boring insects."
          ],
        },
        {
          title: "Mode of Action & Benefits",
          points: [
            "Mode of Action: Acts on insect nerve cells by disrupting sodium channel function, causing paralysis and death.",
            "Fast Knockdown: Provides quick and powerful insect control with long residual activity.",
            "UV Stability: More stable in sunlight compared to many other insecticides, making it ideal for outdoor use."
          ],
        }
      ],
    },

    {
      id: 33,
      name: "CALCIUM CARBONATE",
      image: "/assets/img/api-excipients/calcium-carbonate.jpg",
      usage: [
        {
          title: "Pharmaceuticals",
          points: [
            "Used as a calcium supplement for bone health.",
            "Acts as an antacid to relieve acidity and indigestion.",
            "Used as an excipient in tablet formulations."
          ]
        },
        {
          title: "Food Industry",
          points: [
            "Used as a food additive and calcium fortifier.",
            "Acts as an anti-caking agent in powdered foods.",
            "Commonly used in bakery and dairy products."
          ]
        },
        {
          title: "Industrial Applications",
          points: [
            "Used in cement and construction materials.",
            "Acts as a filler in plastics, paints, and rubber.",
            "Used in paper production for brightness and smoothness."
          ]
        },
        {
          title: "Agriculture",
          points: [
            "Used to neutralize acidic soil (lime treatment).",
            "Provides essential calcium nutrients to crops.",
            "Improves soil structure and fertility."
          ]
        },
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Used in toothpaste as a mild abrasive.",
            "Added in face powders and cosmetics as a base material.",
            "Helps absorb excess oil in skincare products."
          ]
        }
      ]
    },
    {
      id: 34,
      name: "CALCIUM PROPIONATE",
      image: "/assets/img/api-excipients/calcium-propionate.jpg",
      usage: [
        {
          title: "Food Industry",
          points: [
            "Used as a preservative in bakery products like bread and cakes.",
            "Prevents mold and bacterial growth in food items.",
            "Extends shelf life of packaged and processed foods."
          ]
        },
        {
          title: "Animal Feed",
          points: [
            "Used as a feed additive to prevent spoilage.",
            "Inhibits mold growth in stored feed and grains.",
            "Improves safety and quality of animal feed."
          ]
        },
        {
          title: "Agriculture",
          points: [
            "Used in preserving silage and animal fodder.",
            "Helps prevent fungal contamination in crops and storage."
          ]
        },
        {
          title: "Pharmaceuticals",
          points: [
            "Used as an antimicrobial agent in certain formulations.",
            "Helps maintain product stability and shelf life."
          ]
        }
      ]
    },
    {
      id: 35,
      name: "FERROUS SULPHATE",
      image: "/assets/img/api-excipients/ferrous-sulphate.jpg",
      usage: [
        {
          title: "Pharmaceuticals",
          points: [
            "Used to treat and prevent iron deficiency anemia.",
            "Helps in increasing hemoglobin levels in the blood.",
            "Commonly used in iron supplements and tablets.",
            "Supports overall red blood cell production and health."
          ]
        },
        {
          title: "Food Industry",
          points: [
            "Used for iron fortification in food products.",
            "Added to cereals, flour, and nutritional supplements.",
            "Helps prevent iron deficiency in daily diets.",
            "Improves nutritional value of processed foods."
          ]
        },
        {
          title: "Water Treatment",
          points: [
            "Used to remove impurities and phosphates from water.",
            "Acts as a coagulant in wastewater treatment processes.",
            "Helps reduce odor and contamination in water.",
            "Improves overall water clarity and quality."
          ]
        },
        {
          title: "Agriculture",
          points: [
            "Used as a fertilizer to correct iron deficiency in plants.",
            "Prevents yellowing of leaves (chlorosis).",
            "Enhances plant growth and productivity.",
            "Improves soil nutrient composition."
          ]
        },
        {
          title: "Industrial Applications",
          points: [
            "Used in manufacturing of inks and dyes.",
            "Acts as a reducing agent in chemical processes.",
            "Used in cement and construction materials.",
            "Applied in pigments and coloring industries."
          ]
        }
      ]
    },
    {
      id: 36,
      name: "ZINC SULPHATE",
      image: "/assets/img/api-excipients/zinc-sulphate.jpg",
      usage: [
        {
          title: "Pharmaceuticals",
          points: [
            "Used as a dietary supplement to treat zinc deficiency.",
            "Supports immune system function and overall health.",
            "Used in medicines for treating diarrhea and infections.",
            "Helps in wound healing and cell growth."
          ]
        },
        {
          title: "Food Industry",
          points: [
            "Used for zinc fortification in food products.",
            "Added to cereals and nutritional supplements.",
            "Helps improve nutritional value of processed foods.",
            "Prevents zinc deficiency in daily diets."
          ]
        },
        {
          title: "Agriculture",
          points: [
            "Used as a fertilizer to correct zinc deficiency in soil.",
            "Improves crop yield and plant growth.",
            "Enhances enzyme activity in plants.",
            "Prevents leaf discoloration and stunted growth."
          ]
        },
        {
          title: "Animal Feed",
          points: [
            "Used as a feed additive for livestock and poultry.",
            "Promotes growth and improves immunity in animals.",
            "Prevents zinc deficiency in animal diets.",
            "Enhances overall animal health and productivity."
          ]
        },
        {
          title: "Industrial Applications",
          points: [
            "Used in manufacturing of chemicals and dyes.",
            "Applied in water treatment processes.",
            "Used in electroplating and galvanization industries.",
            "Acts as a raw material in various industrial formulations."
          ]
        }
      ]
    },
    {
      id: 37,
      name: "VITAMIN B1 (THIAMINE)",
      image: "/assets/img/api-excipients/vitamin-b1.jpg",
      usage: [
        {
          title: "Pharmaceuticals",
          points: [
            "Used to treat and prevent vitamin B1 deficiency.",
            "Commonly prescribed for conditions like beriberi.",
            "Supports proper nerve and muscle function.",
            "Helps in maintaining overall metabolic health."
          ]
        },
        {
          title: "Health & Nutrition",
          points: [
            "Supports energy metabolism by converting food into energy.",
            "Essential for proper functioning of the nervous system.",
            "Helps improve brain function and mental clarity.",
            "Supports heart health and muscle coordination."
          ]
        },
        {
          title: "Food Industry",
          points: [
            "Used for fortification of food products like cereals and flour.",
            "Enhances nutritional value of processed foods.",
            "Added to dietary supplements and energy drinks.",
            "Helps prevent vitamin deficiency in populations."
          ]
        },
        {
          title: "Animal Feed",
          points: [
            "Used as a nutritional supplement in animal feed.",
            "Supports growth and development in livestock.",
            "Improves metabolism and energy levels in animals.",
            "Prevents vitamin B1 deficiency in animal diets."
          ]
        }
      ]
    },
    {
      id: 38,
      name: "VITAMIN B2 (RIBOFLAVIN)",
      image: "/assets/img/api-excipients/vitamin-b2.jpg",
      usage: [
        {
          title: "Pharmaceuticals",
          points: [
            "Used to treat and prevent vitamin B2 deficiency.",
            "Supports proper growth and development of the body.",
            "Helps in maintaining healthy skin and eyes.",
            "Used in supplements for overall health improvement."
          ]
        },
        {
          title: "Health & Nutrition",
          points: [
            "Supports growth and cell function in the body.",
            "Helps convert food into usable energy.",
            "Acts as an antioxidant to protect cells from damage.",
            "Supports healthy metabolism and immune function."
          ]
        },
        {
          title: "Food Industry",
          points: [
            "Used for fortification of cereals, flour, and dairy products.",
            "Enhances nutritional value of processed foods.",
            "Added to energy drinks and dietary supplements.",
            "Helps prevent vitamin deficiencies in diets."
          ]
        },
        {
          title: "Animal Feed",
          points: [
            "Used as a nutritional additive in animal feed.",
            "Supports growth and development in livestock.",
            "Improves energy metabolism in animals.",
            "Prevents riboflavin deficiency in animal diets."
          ]
        }
      ]
    },
    {
      id: 39,
      name: "VITAMIN B6 (PYRIDOXINE)",
      image: "/assets/img/api-excipients/vitamin-b6.jpg",
      usage: [
        {
          title: "Pharmaceuticals",
          points: [
            "Used to treat and prevent vitamin B6 deficiency.",
            "Supports proper brain development and function.",
            "Used in treatment of anemia and certain nerve disorders.",
            "Included in multivitamin and therapeutic formulations."
          ]
        },
        {
          title: "Health & Nutrition",
          points: [
            "Helps in brain development and cognitive function.",
            "Supports production of neurotransmitters.",
            "Plays a key role in protein metabolism.",
            "Supports immune system and overall health."
          ]
        },
        {
          title: "Food Industry",
          points: [
            "Used for fortification of cereals and nutritional products.",
            "Enhances nutritional value of processed foods.",
            "Added to dietary supplements and health drinks.",
            "Helps prevent vitamin B6 deficiency in diets."
          ]
        },
        {
          title: "Animal Feed",
          points: [
            "Used as a nutritional additive in animal feed.",
            "Supports growth and metabolism in livestock.",
            "Improves overall health and productivity of animals.",
            "Prevents vitamin B6 deficiency in animal diets."
          ]
        }
      ]
    },
    {
      id: 40,
      name: "VITAMIN B12",
      image: "/assets/img/api-excipients/vitamin-b12.jpg",
      usage: [
        {
          title: "Pharmaceuticals",
          points: [
            "Used to treat and prevent vitamin B12 deficiency.",
            "Commonly prescribed for pernicious anemia.",
            "Supports proper nerve function and neurological health.",
            "Included in multivitamin and therapeutic formulations."
          ]
        },
        {
          title: "Health & Nutrition",
          points: [
            "Essential for red blood cell formation.",
            "Supports healthy nerve function and brain health.",
            "Helps in DNA synthesis and cell production.",
            "Boosts energy levels and reduces fatigue."
          ]
        },
        {
          title: "Food Industry",
          points: [
            "Used for fortification of cereals and dairy products.",
            "Enhances nutritional value of processed foods.",
            "Added to dietary supplements and energy drinks.",
            "Helps prevent vitamin B12 deficiency in diets."
          ]
        },
        {
          title: "Animal Feed",
          points: [
            "Used as a nutritional supplement in animal feed.",
            "Supports growth and overall health in livestock.",
            "Improves metabolism and productivity in animals.",
            "Prevents vitamin B12 deficiency in animal diets."
          ]
        }
      ]
    },
    {
      id: 41,
      name: "NIACINAMIDE",
      image: "/assets/img/api-excipients/niacinamide.jpg",
      usage: [
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Used in skincare products for brightening and even skin tone.",
            "Helps reduce dark spots, pigmentation, and blemishes.",
            "Improves skin texture and minimizes appearance of pores.",
            "Supports skin barrier and enhances hydration."
          ]
        },
        {
          title: "Pharmaceuticals",
          points: [
            "Used to treat and prevent niacin (vitamin B3) deficiency.",
            "Included in supplements for overall health support.",
            "Helps in managing certain skin conditions like acne.",
            "Supports proper metabolism and cellular function."
          ]
        },
        {
          title: "Health & Nutrition",
          points: [
            "Supports energy metabolism in the body.",
            "Helps maintain healthy skin, nerves, and digestion.",
            "Plays a role in DNA repair and cell health.",
            "Boosts overall immune system function."
          ]
        },
        {
          title: "Food Industry",
          points: [
            "Used for fortification of cereals and processed foods.",
            "Enhances nutritional value of food products.",
            "Added to dietary supplements and health drinks.",
            "Helps prevent vitamin B3 deficiency in diets."
          ]
        }
      ]
    },
    {
      id: 42,
      name: "BIOTIN",
      image: "/assets/img/api-excipients/biotin.jpg",
      usage: [
        {
          title: "Pharmaceuticals",
          points: [
            "Used to treat and prevent biotin (vitamin B7) deficiency.",
            "Included in supplements for hair, skin, and nail health.",
            "Supports metabolic and enzymatic functions in the body.",
            "Used in therapeutic formulations for deficiency-related conditions."
          ]
        },
        {
          title: "Health & Nutrition",
          points: [
            "Supports healthy hair growth and reduces hair fall.",
            "Improves skin health and maintains a natural glow.",
            "Strengthens nails and prevents brittleness.",
            "Plays a key role in metabolism of carbohydrates, fats, and proteins."
          ]
        },
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Used in shampoos and conditioners for hair strengthening.",
            "Added to skincare products for improved skin texture.",
            "Helps enhance overall appearance of hair and skin.",
            "Supports hydration and nourishment in cosmetic formulations."
          ]
        },
        {
          title: "Food Industry",
          points: [
            "Used for fortification of food and dietary supplements.",
            "Enhances nutritional value of processed foods.",
            "Added to health drinks and multivitamin products.",
            "Helps prevent biotin deficiency in diets."
          ]
        },
        {
          title: "Animal Feed",
          points: [
            "Used as a nutritional additive in animal feed.",
            "Supports growth and coat quality in animals.",
            "Improves metabolism and overall health in livestock.",
            "Prevents biotin deficiency in animal diets."
          ]
        }
      ]
    },
    {
      id: 43,
      name: "CALCIUM PANTOTHENATE",
      image: "/assets/img/api-excipients/calcium-pantothenate.jpg",
      usage: [
        { title: "Pharmaceuticals", points: ["Used to treat and prevent vitamin B5 deficiency.", "Included in multivitamin and therapeutic formulations.", "Supports proper metabolic and enzymatic functions.", "Helps in synthesis of coenzyme A in the body."] },
        { title: "Health & Nutrition", points: ["Supports energy production from carbohydrates and fats.", "Helps maintain healthy skin and hair.", "Supports proper functioning of the nervous system.", "Improves overall metabolic health."] },
        { title: "Food Industry", points: ["Used for fortification of cereals and food products.", "Enhances nutritional value of processed foods.", "Added to dietary supplements and health drinks.", "Helps prevent vitamin deficiencies."] },
        { title: "Animal Feed", points: ["Used as a nutritional additive in animal feed.", "Supports growth and development in livestock.", "Improves metabolism and productivity.", "Prevents vitamin B5 deficiency in animals."] }
      ]
    },
    {
      id: 44,
      name: "SODIUM SACCHARIN",
      image: "/assets/img/api-excipients/sodium-saccharin.jpg",
      usage: [
        { title: "Food Industry", points: ["Used as an artificial sweetener in food and beverages.", "Provides sweetness without adding calories.", "Commonly used in diet and sugar-free products.", "Enhances taste in processed foods."] },
        { title: "Pharmaceuticals", points: ["Used to improve taste of syrups and chewable tablets.", "Masks bitterness of active ingredients.", "Included in oral care and medicinal formulations.", "Helps improve patient compliance."] },
        { title: "Personal Care", points: ["Used in toothpaste and mouthwash for sweetness.", "Enhances flavor without promoting tooth decay.", "Improves user experience in oral care products.", "Maintains product stability."] },
        { title: "Industrial Applications", points: ["Used in electroplating processes.", "Acts as a brightening agent in metal finishing.", "Used in chemical manufacturing.", "Improves product performance in industrial use."] }
      ]
    },
    {
      id: 45,
      name: "SODIUM CYCLAMATE",
      image: "/assets/img/api-excipients/sodium-cyclamate.jpg",
      usage: [
        { title: "Food Industry", points: ["Used as a low-calorie artificial sweetener.", "Commonly used in beverages and sugar-free products.", "Enhances sweetness without increasing sugar content.", "Often blended with other sweeteners for better taste."] },
        { title: "Pharmaceuticals", points: ["Used to improve taste of medicinal syrups and tablets.", "Masks unpleasant flavors of active ingredients.", "Enhances palatability of formulations.", "Supports better patient compliance."] },
        { title: "Dietary Products", points: ["Used in diabetic-friendly and low-calorie foods.", "Helps reduce sugar intake.", "Maintains sweetness in diet products.", "Supports weight management products."] },
        { title: "Industrial Applications", points: ["Used in formulation of specialty food products.", "Acts as a stabilizing sweetening agent.", "Used in research and chemical applications.", "Enhances consistency of formulations."] }
      ]
    },
    {
      id: 46,
      name: "SORBIC ACID",
      image: "/assets/img/api-excipients/sorbic-acid.jpg",
      usage: [
        { title: "Food Industry", points: ["Used as a preservative in food products.", "Prevents growth of molds, yeast, and fungi.", "Extends shelf life of bakery and dairy products.", "Maintains freshness and quality of food."] },
        { title: "Pharmaceuticals", points: ["Used as a preservative in medicinal formulations.", "Prevents microbial contamination.", "Enhances stability of liquid medicines.", "Supports longer shelf life of products."] },
        { title: "Cosmetics and Personal Care", points: ["Used in creams, lotions, and cosmetics as a preservative.", "Prevents microbial growth in formulations.", "Maintains product safety and stability.", "Enhances shelf life of cosmetic products."] },
        { title: "Industrial Applications", points: ["Used in manufacturing of preservatives and chemicals.", "Acts as an antimicrobial agent.", "Used in packaging materials for food safety.", "Improves product durability and storage."] }
      ]
    },
    {
      id: 47,
      name: "BENZOIC ACID",
      image: "/assets/img/api-excipients/benzoic-acid.jpg",
      usage: [
        { title: "Food Industry", points: ["Used as a preservative in acidic food products.", "Prevents growth of bacteria, yeast, and fungi.", "Commonly used in beverages, pickles, and sauces.", "Extends shelf life and maintains food quality."] },
        { title: "Pharmaceuticals", points: ["Used as an antimicrobial agent in medicines.", "Included in topical ointments and creams.", "Helps prevent infection and contamination.", "Enhances stability of pharmaceutical formulations."] },
        { title: "Cosmetics and Personal Care", points: ["Used as a preservative in cosmetic products.", "Prevents microbial growth in creams and lotions.", "Maintains product safety and shelf life.", "Improves stability of formulations."] },
        { title: "Industrial Applications", points: ["Used in manufacturing of resins and plasticizers.", "Acts as an intermediate in chemical production.", "Used in dyes and fragrances.", "Enhances performance of industrial products."] }
      ]
    },
    {
      id: 48,
      name: "LACTIC ACID",
      image: "/assets/img/api-excipients/lactic-acid.jpg",
      usage: [
        { title: "Food Industry", points: ["Used as a preservative and acidity regulator.", "Enhances flavor in dairy products.", "Maintains pH balance.", "Improves shelf life and safety."] },
        { title: "Cosmetics and Personal Care", points: ["Used as an exfoliating agent.", "Improves skin texture.", "Removes dead skin cells.", "Maintains hydration."] },
        { title: "Pharmaceuticals", points: ["Used in medicinal formulations.", "Acts as pH regulator.", "Enhances absorption.", "Improves stability."] },
        { title: "Industrial Applications", points: ["Used in biodegradable plastics.", "Textile processing.", "Cleaning products.", "Eco-friendly agent."] }
      ]
    },
    {
      id: 49,
      name: "MALIC ACID",
      image: "/assets/img/api-excipients/malic-acid.jpg",
      usage: [
        { title: "Food Industry", points: ["Used as flavor enhancer.", "Provides tart taste.", "Acts as acidity regulator.", "Improves product taste."] },
        { title: "Pharmaceuticals", points: ["Used in tablets and syrups.", "Improves absorption.", "Enhances taste.", "Acts as pH adjuster."] },
        { title: "Cosmetics", points: ["Used for exfoliation.", "Improves skin tone.", "Removes dead skin.", "Enhances formulations."] },
        { title: "Industrial Applications", points: ["Used in cleaning agents.", "Acts as stabilizer.", "Used in textiles.", "Improves consistency."] }
      ]
    },
    {
      id: 50,
      name: "TARTARIC ACID",
      image: "/assets/img/api-excipients/tartaric-acid.jpg",
      usage: [
        { title: "Food Industry", points: ["Used in baking.", "Acidity regulator.", "Provides tart flavor.", "Used in wine production."] },
        { title: "Pharmaceuticals", points: ["Used in effervescent tablets.", "Enhances solubility.", "Acts as stabilizer.", "Improves formulation."] },
        { title: "Cosmetics", points: ["Used for exfoliation.", "Improves skin texture.", "Acts as pH adjuster.", "Enhances stability."] },
        { title: "Industrial Applications", points: ["Used in textiles.", "Chelating agent.", "Metal cleaning.", "Improves efficiency."] }
      ]
    },
    {
      id: 51,
      name: "STEARIC ACID",
      image: "/assets/img/api-excipients/tartaric-acid.jpg",
      usage: [
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Used in creams, lotions, and soaps as an emulsifier.",
            "Helps thicken and stabilize cosmetic formulations.",
            "Improves texture and consistency of skincare products.",
            "Provides smooth and soft feel to the skin."
          ]
        },
        {
          title: "Pharmaceuticals",
          points: [
            "Used as a lubricant in tablet manufacturing.",
            "Improves stability of pharmaceutical formulations.",
            "Acts as a binding agent in medicines.",
            "Enhances processing efficiency during production."
          ]
        },
        {
          title: "Industrial Applications",
          points: [
            "Used in production of candles and rubber products.",
            "Acts as a lubricant in plastic manufacturing.",
            "Used in metal polishing and coatings.",
            "Improves durability of industrial products."
          ]
        },
        {
          title: "Food Industry",
          points: [
            "Used as a food additive and stabilizer.",
            "Improves texture of confectionery products.",
            "Acts as an emulsifying agent.",
            "Enhances product consistency and shelf life."
          ]
        }
      ]
    },
    {
      id: 52,
      name: "OLEIC ACID",
      image: "/assets/img/api-excipients/oleic-acid.jpg",
      usage: [
        {
          title: "Industrial Applications",
          points: [
            "Used in lubricants and greases.",
            "Acts as an emulsifier in industrial formulations.",
            "Used in textile and leather processing.",
            "Improves performance of coatings and chemicals."
          ]
        },
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Used in creams and lotions as an emollient.",
            "Helps moisturize and soften the skin.",
            "Improves absorption of active ingredients.",
            "Enhances texture of cosmetic products."
          ]
        },
        {
          title: "Pharmaceuticals",
          points: [
            "Used as an excipient in drug formulations.",
            "Acts as a solubilizing agent.",
            "Enhances bioavailability of active ingredients.",
            "Improves stability of formulations."
          ]
        },
        {
          title: "Food Industry",
          points: [
            "Used as a component in edible oils.",
            "Improves nutritional value of food products.",
            "Acts as a flavor carrier.",
            "Enhances texture and stability of foods."
          ]
        }
      ]
    },
    {
      id: 53,
      name: "MICROCRYSTALLINE CELLULOSE",
      image: "/assets/img/api-excipients/microcrystalline-cellulose.jpg",
      usage: [
        {
          title: "Pharmaceuticals",
          points: [
            "Used as a binder and filler in tablet formulations.",
            "Improves tablet strength and stability.",
            "Enhances disintegration and dissolution of tablets.",
            "Ensures uniformity in drug dosage."
          ]
        },
        {
          title: "Food Industry",
          points: [
            "Used as a stabilizer and thickening agent.",
            "Acts as a fat substitute in low-calorie foods.",
            "Improves texture of processed foods.",
            "Enhances product consistency."
          ]
        },
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Used as a thickening agent in creams and lotions.",
            "Improves texture and application of products.",
            "Helps stabilize emulsions.",
            "Enhances product performance."
          ]
        },
        {
          title: "Industrial Applications",
          points: [
            "Used in paints and coatings.",
            "Acts as a stabilizing agent.",
            "Improves consistency of formulations.",
            "Enhances durability of products."
          ]
        }
      ]
    },
    {
      id: 54,
      name: "LACTOSE MONOHYDRATE",
      image: "/assets/img/api-excipients/lactose-monohydrate.jpg",
      usage: [
        {
          title: "Pharmaceuticals",
          points: [
            "Used as a filler and binder in tablet and capsule formulations.",
            "Improves flow properties of powders.",
            "Ensures uniform distribution of active ingredients.",
            "Enhances stability of pharmaceutical products."
          ]
        },
        {
          title: "Food Industry",
          points: [
            "Used as a sweetener and stabilizer in food products.",
            "Improves texture of bakery and dairy items.",
            "Enhances flavor of processed foods.",
            "Acts as a carrier in food formulations."
          ]
        },
        {
          title: "Infant Nutrition",
          points: [
            "Used in infant formulas as a carbohydrate source.",
            "Supports growth and development of infants.",
            "Provides energy and essential nutrients.",
            "Improves digestibility of formulations."
          ]
        },
        {
          title: "Industrial Applications",
          points: [
            "Used in fermentation processes.",
            "Acts as a carrier for various chemicals.",
            "Improves stability of formulations.",
            "Enhances processing efficiency."
          ]
        }
      ]
    },
    {
      id: 55,
      name: "STARCH",
      image: "/assets/img/api-excipients/starch.jpg",
      usage: [
        {
          title: "Food Industry",
          points: [
            "Used as a thickening agent in soups and sauces.",
            "Improves texture of processed foods.",
            "Acts as a stabilizer in food products.",
            "Enhances consistency and quality."
          ]
        },
        {
          title: "Pharmaceuticals",
          points: [
            "Used as a binder and disintegrant in tablets.",
            "Helps in proper breakdown of tablets.",
            "Improves stability of formulations.",
            "Ensures uniform drug release."
          ]
        },
        {
          title: "Industrial Applications",
          points: [
            "Used in paper and textile industries.",
            "Acts as an adhesive in various applications.",
            "Improves strength of paper products.",
            "Enhances finishing of textiles."
          ]
        },
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Used in powders and dry shampoos.",
            "Absorbs excess oil from skin and hair.",
            "Improves texture of cosmetic products.",
            "Provides smooth application."
          ]
        }
      ]
    },
    {
      id: 56,
      name: "POVIDONE (PVP)",
      image: "/assets/img/api-excipients/povidone-pvp.jpg",
      usage: [
        {
          title: "Pharmaceuticals",
          points: [
            "Used as a binder in tablet and capsule formulations.",
            "Improves solubility and bioavailability of drugs.",
            "Acts as a stabilizer in liquid formulations.",
            "Enhances uniformity and consistency of medicines."
          ]
        },
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Used in hair sprays and styling products.",
            "Provides film-forming and holding properties.",
            "Improves texture and stability of formulations.",
            "Enhances performance of cosmetic products."
          ]
        },
        {
          title: "Industrial Applications",
          points: [
            "Used in adhesives and coatings.",
            "Acts as a dispersing agent in chemical processes.",
            "Improves binding properties in industrial formulations.",
            "Enhances product stability and performance."
          ]
        },
        {
          title: "Food Industry",
          points: [
            "Used as a stabilizer in certain food applications.",
            "Improves texture and consistency.",
            "Acts as a clarifying agent in beverages.",
            "Enhances overall product quality."
          ]
        }
      ]
    },
    {
      id: 57,
      name: "CROSCARMELLOSE SODIUM",
      image: "/assets/img/api-excipients/croscarmellose-sodium.jpg",
      usage: [
        {
          title: "Pharmaceuticals",
          points: [
            "Used as a super disintegrant in tablet formulations.",
            "Ensures rapid breakdown of tablets after ingestion.",
            "Improves dissolution and absorption of drugs.",
            "Enhances effectiveness of oral medications."
          ]
        },
        {
          title: "Food Industry",
          points: [
            "Used as a stabilizer and thickening agent.",
            "Improves texture of processed foods.",
            "Enhances consistency of formulations.",
            "Acts as a binding agent in food products."
          ]
        },
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Used as a stabilizer in cosmetic formulations.",
            "Improves texture and consistency of products.",
            "Enhances performance of creams and lotions.",
            "Helps maintain product uniformity."
          ]
        },
        {
          title: "Industrial Applications",
          points: [
            "Used in coatings and specialty formulations.",
            "Acts as a stabilizing agent.",
            "Improves product consistency.",
            "Enhances durability of industrial products."
          ]
        }
      ]
    },
    {
      id: 58,
      name: "MAGNESIUM STEARATE",
      image: "/assets/img/api-excipients/magnesium-stearate.jpg",
      usage: [
        {
          title: "Pharmaceuticals",
          points: [
            "Used as a lubricant in tablet and capsule manufacturing.",
            "Prevents ingredients from sticking to machinery.",
            "Improves powder flow during production.",
            "Enhances efficiency of manufacturing processes."
          ]
        },
        {
          title: "Food Industry",
          points: [
            "Used as an anti-caking agent in powdered foods.",
            "Improves texture and consistency.",
            "Enhances stability of food products.",
            "Used in supplements and confectionery."
          ]
        },
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Used in powders and foundations.",
            "Improves smoothness and application.",
            "Acts as a binding agent.",
            "Enhances product texture."
          ]
        },
        {
          title: "Industrial Applications",
          points: [
            "Used as a release agent in plastics and rubber.",
            "Prevents sticking in manufacturing processes.",
            "Improves surface finish of products.",
            "Enhances production efficiency."
          ]
        }
      ]
    },
    {
      id: 59,
      name: "COLLOIDAL SILICON DIOXIDE",
      image: "/assets/img/api-excipients/colloidal-silicon-dioxide.jpg",
      usage: [
        {
          title: "Pharmaceuticals",
          points: [
            "Used as an anti-caking agent in powders.",
            "Improves flow properties of formulations.",
            "Enhances stability of pharmaceutical products.",
            "Prevents clumping of ingredients."
          ]
        },
        {
          title: "Food Industry",
          points: [
            "Used as an anti-caking agent in powdered foods.",
            "Improves texture and flow of food products.",
            "Prevents lump formation.",
            "Enhances product stability."
          ]
        },
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Used in powders and skincare products.",
            "Absorbs moisture and oil.",
            "Improves texture and application.",
            "Enhances product performance."
          ]
        },
        {
          title: "Industrial Applications",
          points: [
            "Used in paints, coatings, and adhesives.",
            "Acts as a thickening agent.",
            "Improves product stability.",
            "Enhances durability of formulations."
          ]
        }
      ]
    },
    {
      id: 60,
      name: "TITANIUM DIOXIDE",
      image: "/assets/img/api-excipients/titanium-dioxide.jpg",
      usage: [
        {
          title: "Industrial Applications",
          points: [
            "Used as a white pigment in paints and coatings.",
            "Provides brightness and opacity.",
            "Improves durability of surfaces.",
            "Used in plastics, paper, and inks."
          ]
        },
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Used in sunscreens for UV protection.",
            "Acts as a whitening and brightening agent.",
            "Improves texture of cosmetic products.",
            "Provides opacity in creams and lotions."
          ]
        },
        {
          title: "Pharmaceuticals",
          points: [
            "Used as a coating agent in tablets and capsules.",
            "Provides color and opacity to medicines.",
            "Improves appearance of pharmaceutical products.",
            "Enhances stability of formulations."
          ]
        },
        {
          title: "Food Industry",
          points: [
            "Used as a food coloring agent.",
            "Provides whiteness and opacity.",
            "Improves visual appeal of products.",
            "Used in confectionery and processed foods."
          ]
        }
      ]
    },
    {
      id: 61,
      name: "ISOPROPYL ALCOHOL",
      image: "/assets/img/api-excipients/isopropyl-alcohol.jpg",
      usage: [
        {
          title: "Medical and Healthcare",
          points: [
            "Used as a disinfectant for skin and medical instruments.",
            "Effective against bacteria, viruses, and fungi.",
            "Commonly used in hand sanitizers and wipes.",
            "Helps prevent infections in healthcare settings."
          ]
        },
        {
          title: "Pharmaceuticals",
          points: [
            "Used as a solvent in drug formulations.",
            "Helps in preparation of topical solutions.",
            "Acts as a cleaning agent in manufacturing.",
            "Enhances stability of pharmaceutical products."
          ]
        },
        {
          title: "Industrial Applications",
          points: [
            "Used as a cleaning solvent for electronics and machinery.",
            "Removes oils, grease, and contaminants.",
            "Used in printing and coating industries.",
            "Evaporates quickly without leaving residue."
          ]
        },
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Used in aftershaves and skincare products.",
            "Acts as an antiseptic and astringent.",
            "Helps clean and tighten skin.",
            "Improves formulation consistency."
          ]
        }
      ]
    },
    {
      id: 62,
      name: "ETHANOL",
      image: "/assets/img/api-excipients/ethanol.jpg",
      usage: [
        {
          title: "Industrial Applications",
          points: [
            "Used as a solvent in chemical and pharmaceutical industries.",
            "Applied in production of paints, coatings, and adhesives.",
            "Used in fuel and biofuel applications.",
            "Acts as a cleaning and degreasing agent."
          ]
        },
        {
          title: "Medical and Healthcare",
          points: [
            "Used in sanitizers and disinfectants.",
            "Effective against bacteria and viruses.",
            "Used in preparation of antiseptic solutions.",
            "Helps maintain hygiene and infection control."
          ]
        },
        {
          title: "Pharmaceuticals",
          points: [
            "Used as a solvent in syrups and tinctures.",
            "Helps dissolve active pharmaceutical ingredients.",
            "Enhances stability of formulations.",
            "Used in extraction of medicinal compounds."
          ]
        },
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Used in perfumes and deodorants.",
            "Acts as a solvent for fragrances.",
            "Helps quick drying of products.",
            "Improves texture and consistency."
          ]
        }
      ]
    },
    {
      id: 63,
      name: "HYDROGEN PEROXIDE",
      image: "/assets/img/api-excipients/hydrogen-peroxide.jpg",
      usage: [
        {
          title: "Medical and Healthcare",
          points: [
            "Used as an antiseptic for cleaning wounds.",
            "Helps prevent infection by killing bacteria.",
            "Used in oral care products for whitening and hygiene.",
            "Acts as a disinfectant in healthcare settings."
          ]
        },
        {
          title: "Industrial Applications",
          points: [
            "Used in bleaching of paper and textiles.",
            "Acts as an oxidizing agent in chemical processes.",
            "Used in wastewater treatment.",
            "Helps remove contaminants and impurities."
          ]
        },
        {
          title: "Cosmetics and Personal Care",
          points: [
            "Used in hair bleaching and coloring products.",
            "Helps in teeth whitening formulations.",
            "Acts as a cleansing agent.",
            "Improves hygiene and appearance."
          ]
        },
        {
          title: "Food Industry",
          points: [
            "Used for sterilization of food packaging materials.",
            "Acts as a disinfectant in food processing.",
            "Helps maintain hygiene standards.",
            "Ensures safety of packaged food products."
          ]
        }
      ]
    }
  ];


  const defaultImage =
    "https://upload.wikimedia.org/wikipedia/commons/7/79/Polypropylene_%28PP%29_Granules.jpg";

  const [selectedProduct, setSelectedProduct] = useState(null);
  const closeModal = () => setSelectedProduct(null);
  return (
    <>
      <Breadcrumb
        title="Chemicals"
        backgroundImage={"./assets/img/contact-banner.png"}
        height="40vh"
      />

      <section className="pp-section">
        <div className="container">
          <h2 className="heading01 text-center mb-5">Chemicals</h2>

          <div className="pp-grid">
            {polypropyleneProducts.map((product) => (
              <div className="pp-card" key={product.id}>
                <div className="pp-img-box">
                  <img
                    src={product.image || defaultImage}
                    alt={product.name}
                    onError={(e) => (e.target.src = defaultImage)}
                  />
                </div>
                <div className="pp-info">
                  <h2 className="pp-name">{product.name}</h2>
                  <button
                    className="view-btn"
                    onClick={() => setSelectedProduct(product)}
                  >
                    View Details <ArrowRight size={16} />
                  </button>
                </div>
              </div>
            ))}
          </div>

          {selectedProduct && (
            <div className="modal-overlay" onClick={closeModal}>
              <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
              >
                <img
                  src={selectedProduct.image || defaultImage}
                  alt={selectedProduct.name}
                  className="modal-image"
                />
                <h2 className="modal-title">{selectedProduct.name}</h2>

                <div className="usage-section">
                  {selectedProduct.usage.map((section, index) => (
                    <div key={index} className="usage-block">
                      <h3>{section.title}</h3>
                      <ul>
                        {section.points.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>

                <button className="close-btn" onClick={closeModal}>
                  Close
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Services;
